import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { toast } from 'react-toastify';
import LoadingDots from './LoadingDots';
import Loader from './Loader';

const ListingStep13 = ({ formData, handleChange, prevStep, onRegisterSave }) => {

  const { listingId } = formData;
  const [listingData, setListingData] = useState([]);
  const [reservationOption, setReservationOption] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [question, setQuestion] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [nextLoading, setNextLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchListingData = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
      formData.append('listing_id', listingId);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.getListingData}`,
          data: formData,
        });

        if (response.data.status === 'ok') {
          const listingData = response.data.updated_property_item;
          const { appr_list, resrv_list, offers, place_options_list } = listingData;
          setListingData(response.data.updated_property_item);
          setQuestion(response.data.updated_property_item.questions);

          try {
            const { resrv_list = [], selected = listingData.first_reservation } = listingData;
            setReservationOption(resrv_list);
            setSelectedOption(selected);
            setLoading(false);
          } catch (error) {
            toast.error('Error parsing listing data: ' + error.message);
            console.error('Parsing error:', error);
            setLoading(false);
          }
        } else {
          toast.error('An error occurred while fetching data.');
          setLoading(false);
        }
      } catch (err) {
        console.log(err.message);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchListingData();
  }, [listingId]);


  const saveListing = async () => {
    const hostData = getItemFromLocalStorage('hostProfile');
    const listing_id = listingId;
    const ts = Date.now();

    const updatedPropertyItem = {
      first_reservation: selectedOption,
      resrv_list: reservationOption
    };

    const mergedData = { ...listingData, ...updatedPropertyItem };

    let catData = new FormData();
    catData.append('token', hostData.host_access_token);
    catData.append('listing_id', listing_id);
    catData.append('data', JSON.stringify(mergedData));
    catData.append('ts', ts);

    setNextLoading(true);

    try {
      const response = await axios({
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        url: `${params.baseURL}${params.endpoints.updateListing}`,
        data: catData,
      });

      if (response.data.status === 'done') {
        return true;
      } else {
        toast.error('Failed to save data');
        return false;
      }
    } catch (err) {
      toast.error('An error occurred while saving the listing');
      return false;
    }
  };



  const handleOptionChange = (id) => {
    setSelectedOption(id);
  };

  const faqs = [
    {
      question: "What is Lorem Ipsum?",
      answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
      question: "Where does it come from?",
      answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (loading) {
    return (
      <Loader />
    );
  }

  return (
    <div className="fade-in">
      <button id='host-listing-trigger-13' style={{ display: 'none' }} onClick={() => {
        if (onRegisterSave) {
          onRegisterSave(saveListing);
        }
      }}>Done</button>
      <div className='row'>
        {/*<div className='col-md-4 listing-img-box'>
          <div className='lsib'>
            <img src={'/assets/img/listing/listing_side_img.gif'} alt="Listing Image" className="listing-image" />
            {question && (
              <div className='lsqa-btn'>
                <StarButton text="Guide" link={question.find((q) => q.id === 13)?.link || '#'} />
              </div>
            )}
          </div>
        </div>*/}

        <div className='col-md-7'>

          <div className='ws-cl-header'>
            <div>
              <h4 className='ws-title'>Preferred Guest Type</h4>
              <p class="ws-desc">Define the kind of guests you prefer to host more often at your property. You can choose multiple options from the list below.</p>
            </div>
          </div>

          <div className='st1-desc-box'>
            <div className='ws-row'>

              {reservationOption.length > 0 ? (
                reservationOption.map((option) => (
                  <div key={option.id} className='col-md-12 lb mb-3'>
                    <label className='radio-check-label'>
                      <input
                        type="radio"
                        name="rerv_type"
                        value={option.id}
                        checked={selectedOption === option.id}
                        onChange={() => handleOptionChange(option.id)}
                      />
                      <span>
                        <div>
                          <p>{option.title}</p>
                          <p>{option.desc}</p>
                        </div>
                        <div className='cal-img'>
                          <i className="fas fa-braille"></i>
                        </div>
                      </span>
                    </label>
                  </div>
                ))
              ) : (
                <p>No options available</p>
              )}

            </div>
          </div>

        </div>
        <div className='col-md-1'></div>
        <div className='col-md-4 p-0'>
          <div className='bfhsd'>
            <div className='blog-box'>
              <div class="blog">
                <div class="blog-image">
                  <img src={'https://app.wirestay.com/ws/uploads/blog/1736870810_pi.jpg'} className='img-fluid' alt="" />
                  <div class="date">May 08, 2025</div>
                </div>
                <div class="blog-content">
                  <h2>What is Lorem Ipsum?</h2>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vel metus vel est fermentum consectetur.</p>
                  <a href="#">Read More</a>
                </div>
              </div>
            </div>
            <div className="faq-sticky">
              {faqs.map((faq, index) => (
                <div key={index} className='faqs-list-section'>
                  <div
                    onClick={() => toggleAccordion(index)} className='faqs-qustn-box'
                    style={{
                      backgroundColor: activeIndex === index ? "#f7f7f7" : "#ffffff",
                    }}
                  >
                    {faq.question}
                    <i
                      className={`fas ${activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"
                        }`}
                      style={{
                        transition: "transform 0.3s ease",
                      }}
                    ></i>
                  </div>
                  {activeIndex === index && (
                    <div className='faqs-ans-box'>
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ListingStep13;
